import { Choice, Field, inputClass } from "@/components/settings/primitives";
import { TIME_ZONES } from "@/lib/tasks";
import { cn } from "@/lib/utils";

export const ROLES = ["Founder", "Business owner", "Freelancer", "Creator", "Employee", "Student"];
const DAYS = ["M", "T", "W", "T", "F", "S", "S"];
const DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const textarea = `${inputClass} h-auto min-h-[88px] resize-y py-2.5 leading-relaxed`;

export function TextField({ label, hint, value, onChange, max, multiline, testId, list }) {
  const Tag = multiline ? "textarea" : "input";
  return (
    <Field label={label} hint={hint}>
      <Tag value={value || ""} maxLength={max} list={list} onChange={(e) => onChange(e.target.value)} className={multiline ? textarea : inputClass} data-testid={testId} />
    </Field>
  );
}

export function ToneField({ value, onChange }) {
  return (
    <Field label="Preferred tone">
      <Choice value={value || "none"} onChange={(v) => onChange(v === "none" ? null : v)} testIdPrefix="about-tone"
        options={[{ value: "none", label: "No preference" }, { value: "friendly", label: "Friendly" }, { value: "professional", label: "Professional" }, { value: "direct", label: "Direct" }]} />
    </Field>
  );
}

export function WorkHoursField({ form, set }) {
  const toggle = (d) => set({ work_days: form.work_days.includes(d) ? form.work_days.filter((x) => x !== d) : [...form.work_days, d].sort() });
  return (
    <Field label="Working hours" hint="Leave empty if you don't keep set hours.">
      <div className="flex flex-wrap items-center gap-2">
        <input type="time" value={form.work_start || ""} onChange={(e) => set({ work_start: e.target.value || null })} className={cn(inputClass, "w-36 [color-scheme:dark]")} aria-label="Start time" data-testid="about-work-start" />
        <span className="text-sm text-zinc-500">to</span>
        <input type="time" value={form.work_end || ""} onChange={(e) => set({ work_end: e.target.value || null })} className={cn(inputClass, "w-36 [color-scheme:dark]")} aria-label="End time" data-testid="about-work-end" />
      </div>
      <div className="mt-2 flex gap-1">
        {DAYS.map((d, i) => (
          <button key={DAY_NAMES[i]} type="button" aria-label={DAY_NAMES[i]} aria-pressed={form.work_days.includes(i + 1)} onClick={() => toggle(i + 1)} data-testid={`about-work-day-${i + 1}`}
            className={cn("h-8 w-8 rounded-full text-xs transition-colors", form.work_days.includes(i + 1) ? "bg-white text-ink-950" : "border border-white/10 text-zinc-400 hover:text-white")}>
            {d}
          </button>
        ))}
      </div>
    </Field>
  );
}

export function TimezoneField({ value, onChange }) {
  const options = !value || TIME_ZONES.includes(value) ? TIME_ZONES : [value, ...TIME_ZONES];
  return (
    <Field label="Time zone" hint="Saved straight away. Also used for your account's dates and times.">
      <select value={value || ""} onChange={(e) => e.target.value && onChange(e.target.value)} className={`${inputClass} [color-scheme:dark]`} data-testid="about-timezone-select">
        {!value && <option value="">Not set</option>}
        {options.map((z) => <option key={z} value={z}>{z.replace(/_/g, " ")}</option>)}
      </select>
    </Field>
  );
}
